import React from 'react';

const ComputerScience = () => {
  return (
    <div>
      ComputerScience
      ComputerScience
    </div>
  );
}

export default ComputerScience;
